import { delayRepayRoute } from './helpers';
import { DelayRepayPages } from '../../../../src/constants/AppConstants';

export default delayRepayRoute(DelayRepayPages.CUSTOMER, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/delayRepay/CustomerDetails').default);
        }, 'delayrepay-customer');
    }
});
